<app-partner-registration-form #partnerRegistrationForm (eventRegister)="onRegister()" (eventBack)="onBack()"
    (eventLogin)="onLogin()" [showLoginUrl]="allowedLogin" ></app-partner-registration-form>